import React from "react";
import { useNavigate } from "react-router-dom";
import EditIcon from "../../static/images/Editicon.svg";
import DeleteIcon from "../../static/images/Archive.svg";
import { service } from "../../../services/AxiosServices";
import Spinner from '../atoms/Spinner';
import { format, parseISO } from 'date-fns';
import { toast } from "react-toastify";
interface PartnerMember {
  id: number;
  first_name: string;
  last_name: string;
}

interface PartnerCompany {
  id: number;
  company_name: string;
  users: PartnerMember[];
  created_at: string;
  updated_at?: string;
  deleted_at?: string | null;
}

interface ManagePartnerTempletProps {
  companies: PartnerCompany[];
  loading: boolean;
  error: string | null;
  onRemoveCompany: (companyId: number) => void;
}

const ManagePartnerTemplet: React.FC<ManagePartnerTempletProps> = ({
  companies,
  loading,
  error,
  onRemoveCompany,
}) => {
  const navigate = useNavigate();
  const onEdit = (company: PartnerCompany) => {
    console.log("Edit", company);
    navigate(`/partner-tab?id=${company.id}`);
  };
  
  const onArchive = async (companyId: number) => {
    onRemoveCompany(companyId);
    try {
      await service(`/archive-company/${companyId}`, "post");
      console.log("Company archived successfully.");
    } catch (error) {
      console.error("Failed to archive company:", error);
    }
    toast.success("Partner company deleted successfully!");
  };
  return (
    <div className="table-responsive p-4">
      {loading ? (
        <p><Spinner /></p>
      ) : (
        <>
        {!!error &&  <div className="alert alert-danger"><li>{error}</li></div>}
        <table className="table">
          <thead className="table-secondary">
            <tr>
              <th className="p-3">Company name</th>
              <th className="p-3">Users</th>
              <th className="p-3">Created at</th>
              <th className="p-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {companies.map((company) => (
              <tr key={company.id}>
                <td className="p-3">{company.company_name}</td>
                <td className="p-3">
                  {company.users
                    .map((user) => `${user.first_name} ${user.last_name}`)
                    .join(", ")}
                </td>
                <td className="p-3">{company.created_at ? format(parseISO(company.created_at), 'dd-MM-yyyy, HH:mm') : ''}</td>
                <td className="p-3">
                  <div className="d-flex">
                    <button
                      className=""
                      onClick={() => onEdit(company)}
                      title="Edit"
                    >
                      <img src={EditIcon} alt="Edit" className="me-2" />
                    </button>
                    <button
                      className="ms-2"
                      onClick={() => onArchive(company.id)}
                      title="Delete"
                    >
                      <img src={DeleteIcon} alt="Archive" className="me-2" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {companies.length === 0 && (
              <tr>
                <td colSpan={4} className="text-center p-3">
                  No partner companies found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        </>
      )}
    </div>
  );
};

export default ManagePartnerTemplet;
